import { configureStore } from '@reduxjs/toolkit';
import appGeneralReducer from './slices/appGeneralSlice';
import stepManagementReducer from './slices/stepManagementSlice';
import paymentManagementReducer from './slices/paymentManagementSlice';
import transactionsReducer from './slices/transactionsSlice';
import notificationReducer from './slices/notificationSlice'

export const store = configureStore({
    reducer: {
        appGeneral: appGeneralReducer,
        stepManagement: stepManagementReducer,
        paymentManagement: paymentManagementReducer,
        transactions: transactionsReducer,
        notifications: notificationReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
